import { render, staticRenderFns } from "./codeTestPartBottomSheet.vue?vue&type=template&id=38983f28&scoped=true&"
import script from "./codeTestPartBottomSheet.vue?vue&type=script&lang=js&"
export * from "./codeTestPartBottomSheet.vue?vue&type=script&lang=js&"
import style0 from "./codeTestPartBottomSheet.vue?vue&type=style&index=0&id=38983f28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38983f28",
  null
  
)

export default component.exports